import starIcon from "../../Img/star-icon.png";
import team1 from "../../Img/team1.jpg";

const teamData = [
  {
    icon: starIcon,
    title: "Team",
    head: "Our Awesome Team",
    detail:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    teamList: [
      {
        name: "Ajay Soni",
        designation: "UI/UX | Marketing Manager",
        teamImg:
          "https://firebasestorage.googleapis.com/v0/b/sr-devops.appspot.com/o/WhatsApp%20Image%202021-07-09%20at%2010.25.47%20PM.jpeg?alt=media&token=191a41e1-5d49-457f-9231-ea03f9d7bdac",
        insta: "https://instagram.com/ajaysoni240",
        fb: "https://facebook.com/ajaysoni240",
      },
    ],
  },
];

export default teamData;
